/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SafeWaitHandle model module.
 * @module model/SafeWaitHandle
 * @version V1
 */
class SafeWaitHandle {
    /**
     * Constructs a new <code>SafeWaitHandle</code>.
     * @alias module:model/SafeWaitHandle
     */
    constructor() { 
        
        SafeWaitHandle.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SafeWaitHandle</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SafeWaitHandle} obj Optional instance to populate.
     * @return {module:model/SafeWaitHandle} The populated <code>SafeWaitHandle</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SafeWaitHandle();

            if (data.hasOwnProperty('isInvalid')) {
                obj['isInvalid'] = ApiClient.convertToType(data['isInvalid'], 'Boolean');
            }
            if (data.hasOwnProperty('isClosed')) {
                obj['isClosed'] = ApiClient.convertToType(data['isClosed'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SafeWaitHandle</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SafeWaitHandle</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Boolean} isInvalid
 */
SafeWaitHandle.prototype['isInvalid'] = undefined;

/**
 * @member {Boolean} isClosed
 */
SafeWaitHandle.prototype['isClosed'] = undefined;






export default SafeWaitHandle;

